export const removeLeadingZero = number => {
  let numberStr = number.toString();

  if (numberStr.match(/^0[0-9]/)) {
    numberStr = numberStr.slice(1);
  }

  return numberStr;
};
